import script from "./Table_Treatments_AllVariants.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_Treatments_AllVariants.vue?vue&type=script&setup=true&lang=js"

import "./Table_Treatments_AllVariants.vue?vue&type=style&index=0&id=8685d1a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8685d1a2"]])

export default __exports__